export const WISHLIST_ENUM = {
    WISHLIST: "WISHLIST",
    MOVEDTOCART: "MOVEDTOCART"
}
export const CART_STATUS_ENUM = {
    PLACED: 'PLACED',
    CANCELLED: 'CANCELLED',
    UNPAID: 'UNPAID',
    REFUND: 'REFUND',
    DELIVERED: 'DELIVERED',
    ONWAY: 'ONWAY',
    OUTFORDELIVERY: 'OUTFORDELIVERY',
    CONFIRMED: 'CONFIRMED',
    PAID: 'PAID',
    PROCESSING:'PROCESSING',
    NEW: 'NEW'
}

export const CART_ITEM_ENUM = {
    NEW: 'NEW',
}
export  const PAYMENT_GATEWAY = {
    UPI: 'UPI',
    PAYPAL: 'PAYPAL',
    YESBANK: 'YESBANKLTD',
    COD: 'COD',
    HDFC:'HDFC'
}